import AnimateIn from './AnimateIn';
import classNames from 'classnames';
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const BlockQuote = ({ component }) => (
  <AnimateIn
    className={classNames('quote', 'g-row')}
  >
    {component._editable && <StoryblokEditableComment text={component._editable} />}
  	<blockquote>
	    <div className={classNames('quote__body', {
        ['quote__body--black']: component.color === 'black',
      })}>
        {component.body}
      </div>
      <footer className="quote__footer">{component.footer}</footer>
    </blockquote>
  </AnimateIn>
);

export default BlockQuote;